import { render, staticRenderFns } from "./AppSpotlight.vue?vue&type=template&id=be55d056&scoped=true"
import script from "./AppSpotlight.vue?vue&type=script&lang=js"
export * from "./AppSpotlight.vue?vue&type=script&lang=js"
import style0 from "./AppSpotlight.vue?vue&type=style&index=0&id=be55d056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be55d056",
  null
  
)

export default component.exports